import React from 'react';
import { loadingTypes } from "./utils";

const LoadingDisplay = (props) => {
  const { width = "100", type = loadingTypes.line, ...otherProps } = props || {};

  return <div {...otherProps} data-testid={"loading"} className={`mls-o-loading mls-o-loading--glow mls-o-loading--${type} mls-o-loading--${width}`} />;
};

export default LoadingDisplay;
